export const navigationRoutes = {
  home: '/',
  invoices: '/invoices',
  transactions: '/transactions',
  configuration: '/configuration',
  storeData: '/store/data',
  storeTPV: '/store/tpv',
  tpvsExcelUpload: '/tpvs-excel-upload',
  storeContacts: '/store/contacts',
  storeStickers: '/store/stickers',
  changeBankAccount: '/account/change-bank-account',
  contractsBillingData: '/contracts/billing-data',
  contractsProductsData: '/contracts/products-data',
  contractNewProducts: '/contracts/new-products',
  accessRoles: '/access-roles',

  // AutoEnrollment Routes
  autoEnrollment: '/auto-enrollment',

  // Cashback Routes
  cashbackAutoEnrollment: '/auto-enrollment-cashback',

  // Help Center
  newTicket: '/help-center-new',
  myTickets: '/help-center-my-tickets',
  ticketDetail: '/help-center-ticket/:ticketId',
  reopenTicket: '/help-center-ticket/:ticketId/reopen',
}
export const registerStepTwoRoute = "/registerStepTwo"
export const openNavigationRoutes = {
  logaltyCheckStatus: '/external-route/check-status',
  accountDeleted: '/external-route/account-deleted',

  // Account Routes
  login: '/login',
  otpAuth: '/otp-auth',
  registerStepOne: '/registerStepOne',
  registerStepTwo: registerStepTwoRoute,
  registerStepThree: '/registerStepThree',
  registerEmailSuccess: '/registerStepOne/EmailSuccess',
  passwordRecoveryStep1: '/MerchantPasswordRecovery/Step1',
  passwordRecoveryStep2: '/MerchantPasswordRecovery/Step2',
  passwordRecoveryEmailSuccess: '/MerchantPasswordRecovery/EmailSuccess',
  passwordRecoveryPasswordChangeSuccess: '/MerchantPasswordRecovery/PasswordSuccess',
  passwordRecoveryPasswordChangeError: '/MerchantPasswordRecovery/PasswordError',

  // AutoEnrollment Routes
  otp: '/otp',
  signUp: '/sign-up',
}
